import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { UserIdService } from '../../auth';
import { GlobalMessageService, GlobalMessageType } from '../../global-message';
import { DataImportsConnector } from '../connectors/data-imports.connector';
import { DataImportsFacade } from '../facades';

@Injectable()
export class DataImportsService implements DataImportsFacade {
  constructor(
    private userIdService: UserIdService,
    private dataImportsConnector: DataImportsConnector,
    private globalMessageService: GlobalMessageService
  ) {}

  loadDataImportXlsReport(code: string): Observable<Blob> {
    return this.userIdService
      .takeUserId(true)
      .pipe(switchMap((userId) => this.dataImportsConnector.loadDataImportXlsReport(userId, code)));
  }

  handleErrorWhileDownloadingErrorReport(): void {
    this.globalMessageService.add({ key: 'common.downloadErrorReportFailure_message' }, GlobalMessageType.MSG_TYPE_ERROR, 3000);
  }
}
